<div class="outerwrap" [hidden]="!ViewReady" fxLayout="column" fxLayoutAlign="start stretch">
    <h2 class="mat-headline">Referrals For {{ User.FirstName | titleCase }} {{ User.LastName | titleCase }}</h2>
    <div>
        The following requests have been forwarded to you by
        <span>{{ User?.CurrentRole === 'Cabinet' ? 'the IRIS facilitator' : 'your supervisor' }}</span> for your response. You may
        click on the "View" button to view the details of the request and to take appropriate action for handling the response.
    </div>
    <div *ngIf="HasDesigneeEntries">
        <span
            ><strong>Note: </strong>Entries in the list provided that bear the <mat-icon>account_circle</mat-icon> icon indicate
            entries that you are viewing because a cabinet member has designated you as an "Out of Office" designee for the
            request.</span
        >
    </div>
    <table
        class="fullwidth"
        *ngIf="SearchConducted"
        mat-table
        [dataSource]="ReferralsData"
        matSort
        matSortActive="DueDate"
        matSortDirection="asc"
    >
        <ng-container matColumnDef="DesigneeFlag">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered"></th>
            <td mat-cell *matCellDef="let req" class="centered">
                <mat-icon *ngIf="req.AsDesignee" title="Referral is a cabinet member designee entry.">account_circle</mat-icon>
            </td>
        </ng-container>
        <ng-container matColumnDef="RequestIssueNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Request #</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.RequestIssueNumber | requestIssue: req.FiscalYear }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="BoardMember">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Board Member</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.RequestedByFirstName | titleCase }} {{ req.RequestedByLastName | titleCase }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DueDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Due</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span *ngIf="req.DueDate">{{ req.DueDate | date: 'M/d/yyyy' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Priority">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Priority</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.PriorityShortLabel || '' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Subject">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Subject</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.Subject }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="CategoryLabel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Category</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.CategoryLabel }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="StatusLabel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Status</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <div>{{ req.StatusLabel }}</div>
                <div *ngIf="req.Completed || req.Cancelled">({{ req.DateClosed | date: 'M/d/yyyy' }})</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateCreated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Opened</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateClosed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Closed</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span *ngIf="!req.Completed && !req.Cancelled">N/A</span>
                <span *ngIf="req.Completed || req.Cancelled">{{ req.DateClosed | date: 'M/d/yyyy' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Actions</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <button type="button" mat-raised-button color="accent" (click)="HandleView(req)" [disabled]="req.Status === 'CANCEL'">
                    View
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let req" [attr.colspan]="VisibleHeaders?.length">
                <em>There are no referrals for you at this time.</em>
            </td>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <th mat-header-cell *matHeaderCellDef>My Referrals</th>
            <td mat-cell *matCellDef="let req">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div fxLayout="row" fxLayoutAlign="start start">
                            <mat-icon *ngIf="req.AsDesignee" title="Referral is a cabinet member designee entry."
                                >account_circle</mat-icon
                            >
                            <app-form-label>Request #</app-form-label>
                        </div>
                        <span>{{ req.RequestIssueNumber | requestIssue: req.FiscalYear }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Board Member</app-form-label>
                        <span>{{ req.RequestedByFirstName | titleCase }} {{ req.RequestedByLastName | titleCase }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Due</app-form-label>
                        <span *ngIf="req.DueDate">{{ req.DueDate | date: 'M/d/yyyy' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Priority</app-form-label>
                        <span>{{ req.PriorityShortLabel || '' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Subject</app-form-label>
                        <span>{{ req.Subject }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Category</app-form-label>
                        <span>{{ req.CategoryLabel }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Status</app-form-label>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <span>{{ req.StatusLabel }}</span>
                            <div *ngIf="req.Completed || req.Cancelled">({{ req.DateClosed | date: 'M/d/yyyy' }})</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Opened</app-form-label>
                        <span>{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
                    </div>
                    <!-- <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Closed</app-form-label>
                        <span *ngIf="!req.Completed && !req.Cancelled">N/A</span>
                        <span *ngIf="req.Completed || req.Cancelled">{{ req.DateClosed | date: 'M/d/yyyy' }}</span>
                    </div> -->
                    <div fxLayout="row" fxLayoutAlign="center start" class="margin-bottom">
                        <button
                            type="button"
                            mat-raised-button
                            color="accent"
                            (click)="HandleView(req)"
                            [disabled]="req.Status === 'CANCEL'"
                        >
                            View
                        </button>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
        <tr mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></tr>
    </table>

    <mat-paginator
        #paginator
        [length]="ReferralsData?.data?.length"
        [pageIndex]="0"
        [pageSize]="SmallDisplay ? 5 : 10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
</div>
